<div style="margin-left: 20px;">
  <form [formGroup]="SettingsForm">
    <div class="form-group row">
      <fieldset>
        <legend>
          <input type="checkbox" [formControl]="EnableExport" />
          <span class="uv-checkbox-label">Enable Export</span>
        </legend>
      </fieldset>
    </div>
    <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
      <div class="uv-row">
        <span class="col-lg-2">Target Server Settings:</span>
        <select class="col-lg-3" [formControl]="ServerSettings" [ngClass]="{'show-error':SettingsForm.hasError('validPrtgSettings')}">
          @for (settings of PrtgSettings; track settings) {
            <option value="{{settings.GUID}}">{{settings.Name}}</option>
          }
        </select>
        <span style="margin-left: 20px;">Summary:</span>
        <span style="margin-left: 10px;">{{ServerSettingsSummary}}</span>
      </div>
    </div>
    @if (SettingsForm.hasError('validPrtgSettings')) {
      <div class="form-group row">
        <div class="uv-row">
          <span class="col-lg-2">&nbsp;</span>
          <span class="col-lg-3 alert alert-danger">This value is required</span>
        </div>
      </div>
    }
    <div class="mb-3"></div>
    <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportEnabled}">
      <div class="uv-row">
        <span class="col-lg-2">Do export from:</span>
        <select class="col-lg-3" [formControl]="ExportOrigin"
          [ngClass]="{'show-error':SettingsForm.hasError('validExportOrigin'), 'uv-disabled':!EnableExportOrigin}">
          <option value="agent">Agent</option>
          <option value="server">Server</option>
        </select>
        <button [disabled]="!isLicenseValid" type="button" style="margin-left: 20px !important; margin-top: -4px !important;" pButton icon="fa fa-file-o" iconPos="left"
        label="Export Now (from server)" (click)="ExportNow()"></button>
        <button type="button" pButton label="Test PRTG Connection" title="Test/Verify PRTG connection credentials" style="margin-left: 20px !important; margin-top: -4px !important;"
        (click)="testPrtgConnect()"></button>
      </div>
    </div>
    <div class="form-group row" [ngClass]="{'uv-disabled':!ExportEnabled}">
      <div class="uv-row">
        <span class="col-lg-2">Export Type:</span>
        <span class="col-lg-3">
          <div>
            <input type="radio" name="prtgExportType" value="1" [checked]="ExportDataOnly.value == '1'"
              [formControl]="ExportDataOnly" />
              <span class="uv-checkbox-label">Export Data Only</span>
            </div>
            <div class="explanatory-text">
              (export data to existing PRTG groups/devices)
            </div>
          </span>
          <span class="col-lg-3">
            <div>
              <input type="radio" name="prtgExportType" value="2" [checked]="ExportDataOnly.value == '2'"
                [formControl]="ExportDataOnly" />
                <span class="uv-checkbox-label">Export Groups/Devices</span>
              </div>
              <div class="explanatory-text">
                (create and update PRTG groups/devices/sensors)
              </div>
            </span>
          </div>
          <div class="mb-3"></div>
          <div class="uv-row" [ngClass]="{'uv-disabled': ExportDataOnly.value == '2' }">
            <span class="col-lg-2">Target Server 2:</span>
            <select class="col-lg-3" [formControl]="ServerSettings2">
              @for (settings of PrtgSettings; track settings) {
                <option value="{{settings.GUID}}">{{settings.Name}}</option>
              }
            </select>
          </div>
          <div class="mb-3"></div>
          <div class="uv-row" [ngClass]="{'uv-disabled': ExportDataOnly.value == '2' }">
            <span class="col-lg-2">Target Server 3:</span>
            <select class="col-lg-3" [formControl]="ServerSettings3">
              @for (settings of PrtgSettings; track settings) {
                <option value="{{settings.GUID}}">{{settings.Name}}</option>
              }
            </select>
          </div>
          <div class="mb-3"></div>
          <div class="uv-row" [ngClass]="{'uv-disabled': ExportDataOnly.value == '2' }">
            <span class="col-lg-2">Target Server 4:</span>
            <select class="col-lg-3" [formControl]="ServerSettings4">
              @for (settings of PrtgSettings; track settings) {
                <option value="{{settings.GUID}}">{{settings.Name}}</option>
              }
            </select>
          </div>

        </div>
        <hr style="margin-top: 20px; margin-bottom: 20px;" />
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div class="uv-row">
            <span class="col-lg-2">Parent Group Name or ID:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="ParentGroupName" />
            <button type="button" pButton label="Browse..." style="margin-left: 10px;"
              (click)="browseParentGroup()"
              [disabled]="!canBrowsePrtgGroups || !ExportDevices"></button>
          </div>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div class="uv-row">
            <span class="col-lg-2" title="All devices from discovery result will be add/updated to this group. Leave blank to only export Groups/Maps below">Group Name:</span>
            <input class="col-lg-3" type="text" pInputText [formControl]="GroupName" [ngClass]="{'show-error':SettingsForm.hasError('validGroupName')}" />
            <button type="button" pButton label="Browse..." style="margin-left: 10px;"
              (click)="browseGroupName()"
              [disabled]="!canBrowsePrtgGroups || !ExportDevices"></button>
          </div>
        </div>
        @if (SettingsForm.hasError('validGroupName')) {
          <div class="form-group row" [ngClass]="{'uv-disabled':!ExportDevices}">
            <span class="col-lg-2"></span>
            <span class="col-lg-3 alert alert-danger">This value is required</span>
          </div>
        }
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div class="uv-row">
            <span style="margin-left: 20px;">
              <input type="checkbox" [formControl]="RemoveMissingDevices" />
              <span class="uv-checkbox-label">Remove PRTG Devices</span>
            </span>
          </div>
        </div>
        <div class="mb-3"></div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div class="uv-row">
            <span style="margin-left: 20px;">
              <input type="checkbox" [formControl]="ExportMapsOnly" />
              <span class="uv-checkbox-label">Export Maps Only</span>
            </span>
          </div>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div class="uv-row">
            <span style="margin-left: 20px;">
              <input type="checkbox" [formControl]="MergeMapsOnExport" />
              <span class="uv-checkbox-label">Merge Maps</span>
            </span>
          </div>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <fieldset>
            <legend>Sensors</legend>
            <span>Check all sensor types to be automatically added to exported devices:</span>
          </fieldset>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div class="sensor-select">
            <p-multiSelect styleClass="sensor-select" [options]="SensorOptions" [filter]="false" [formControl]="SensorTypes"
              [maxSelectedLabels]="5">
            </p-multiSelect>
          </div>
        </div>
        <div class="form-group row mb-3" [ngClass]="{'uv-disabled':!ExportDevices}">
          <div style="margin-left: 20px;">
            <input type="checkbox" [formControl]="UseTemplates" />
            <span class="uv-checkbox-label">Use PRTG Templates</span>
          </div>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!ExportDevices}">
          <fieldset>
            <legend>
              <input type="checkbox" [formControl]="ExportMaps" [disabled]="!ExportDevices" />
              <span class="uv-checkbox-label">Export Groups/Maps</span>
            </legend>
          </fieldset>
        </div>
        <div class="form-group row" [ngClass]="{'uv-disabled':!EnableMapPicker}">
          <div class="col-lg-12">
            <p-table [scrollable]="true" scrollHeight="300px" scrollWidth="900px" [value]="MapData"
              (sortFunction)="doCustomSort($event)" [customSort]="true" [resizableColumns]="true">

              <ng-template pTemplate="header">
                <tr>
                  <th class="uv-table-checkbox" style="text-align: center;">
                    <input type="checkbox" [checked]="SelectAllState" (change)="SelectAllChanged($event)" [disabled]="!ExportDevices || !ExportMaps.value" />
                  </th>
                  <th [ngStyle]="{'width':'200px'}" pResizableColumn pSortableColumn="Name">
                    Name
                    <p-sortIcon field="Name"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{'width':'200px'}" pResizableColumn pSortableColumn="Description">
                    Description
                    <p-sortIcon field="Description"></p-sortIcon>
                  </th>
                  <th [ngStyle]="{'width':'250px'}" pResizableColumn>
                    GUID
                  </th>
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData>
                <tr>
                  <td class="uv-table-checkbox" style="text-align: center;">
                    <input type="checkbox" [checked]="rowData.Selected" (change)="MapSelectionChanged($event, rowData)" [disabled]="!ExportDevices || !ExportMaps.value" />
                  </td>
                  <td [ngStyle]="{'width':'200px'}">
                    <span class="uv-table-value">{{ rowData.Name }}</span>
                  </td>
                  <td [ngStyle]="{'width':'200px'}">
                    <span class="uv-table-value">{{ rowData.Description }}</span>
                  </td>
                  <td [ngStyle]="{'width':'250px'}">
                    <span class="uv-table-value">{{ rowData.Guid }}</span>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </form>

      <prtg-group-picker [(display)]="parentPickerVisible"
        [netViewGuid]="pickerNetViewGuid"
        [prtgSettingsGuid]="pickerPrtgSettingsGuid"
        title="Select Parent Group"
        (onSelect)="onParentGroupPicked($event)"></prtg-group-picker>

      <prtg-group-picker [(display)]="groupPickerVisible"
        [netViewGuid]="pickerNetViewGuid"
        [prtgSettingsGuid]="pickerPrtgSettingsGuid"
        title="Select PRTG Group"
        (onSelect)="onGroupNamePicked($event)"></prtg-group-picker>
    </div>
